import { useState, useEffect, useContext } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Msg, Button } from 'react-weui';
import PropTypes from 'prop-types';
import { formatDate, formatNumber } from 'lib/formatter.ts';
import User from 'services/user2';
import TopNav from 'components/topNav.js';
import * as MobileActions from 'actions/index.ts';
import CompanyService from 'services/company2';
//审批流状态
import WorkflowStatus from 'components/workflowStatus.jsx';
//审批流按钮
import WorkflowButtons from 'components/workflowButtons.jsx';
import Util from 'lib/util.js';
import useDetail from 'hooks/useDetail';
import { ActionContext } from 'actions/context';
import Modal from 'components/modal';
import CommonFns from 'functions/common.ts';
import Download from 'components/download.js';
import Big from 'big.js';
import ReceiveService from 'services/receive';
let isBig = Util.isBig;

function ReceiveAcceptanceDetail(props) {
  const Config = {
    purchase: {
      title: '采购验收详情',
      apiPath: '/purchaseAccp/getDetail',
      confirmApiPath: '/purchaseAccp/confirm',
      customerNameKey: 'companyName',
      companyCodeKey: 'companyCode',
      vendorNameKey: 'innerVendorName',
      arrEnumField: [
        {
          mainKey: 'B02_Po_Assets_Acceptance_Status',
          subKey: 'status',
          value: 'statusName'
        }
      ],
      idField: 'accpXkNo',
      wfmCode: '1028'
    }
  };
  const config = Config[props.type];

  const {
    companyCode,
    inited,
    error,
    updateTs,
    redirect,
    decimalPlace,
    fileList,
    setShowLoading,
    setFileList,
    detail,
    setDetail,
    workflow,
    forceUpdate,
    self
  } = useDetail(props, config);

  const { state, dispatch } = useContext(ActionContext);
  const [boxState, setBoxState] = useState({
    1: true
  });
  const [list, setList] = useState([]);

  //处理详情数据
  self.afterGetDetail = function (data) {
    data.lineList.forEach((item, i) => {
      Util.genExtendFields(item);
      item.taxRateShow = isBig(item.taxRate)
        ? Big(item.taxRate).times(100).valueOf() + '%'
        : '--'; //按百分比显示税率
      item.payRatioShow = isBig(item.payRatio)
        ? Big(item.payRatio).times(100).valueOf() + '%'
        : '--'; //按百分比显示税率
    });
    setDetail(data);
  };

  //初始化默认企业
  useEffect(() => {
    const { match } = props;
    let routeCompanyCode = match.params.companyCode;
    self.init(routeCompanyCode);
    //卸载时
    return function unmount() {
      if (self.toastTimer) {
        clearTimeout(self.toastTimer);
      }
      if (self.loadingTimer) {
        clearTimeout(self.loadingTimer);
      }
      if (self.errorTimer) {
        clearTimeout(self.errorTimer);
      }
    };
  }, [self, props]);

  //根据依赖多次执行
  useEffect(() => {
    self.getDetail();
  }, [companyCode, self]);

  // function handleBoxState(idx) {
  //   boxState[idx] = !boxState[idx];
  //   setBoxState(boxState);
  //   forceUpdate();
  // }

  function showFileList(item) {
    const { actions } = props;
    let cCode = item.companyCode;
    setShowLoading(true);
    item.businessKey = item.lineNo ? self.id + '_' + item.lineNo : self.id;
    CompanyService.getFileList(79, item.businessKey, '', '', cCode).then(
      res => {
        setShowLoading(false);
        if (Array.isArray(res)) {
          let arr = res.map(row => {
            return { ...row };
          });
          setFileList(arr);
        }
      }
    );
    actions.openDownloadModal();
  }

  //确认
  function confirm() {
    let postbody = getPostbody(config.confirmApiPath);
    ReceiveService.recAccConfirm(
      postbody,
      '确认验收单？',
      () => {
        self.getDetail();
      },
      dispatch
    );
  }

  //获取提交参数
  function getPostbody(apiPath) {
    let postbody = {
      accpXkNo: self.id,
      companyCode: companyCode,
      apiPath: apiPath
    };
    return postbody;
  }

  //显示错误
  if (error !== null) {
    return <Msg {...error} />;
  }

  if (redirect !== null) {
    return <Redirect to={redirect} />;
  }

  return (
    <div>
      <TopNav inited={inited} />
      <div className="m-details-container">
        <div className="m-details-item">
          <div className="details-item-title">
            <label>基础信息</label>
          </div>
          <div className="details-item-content">
            <div className="content-line">
              <ul className="field-list">
                <li>
                  <span className="field-label">供应商</span>
                  <div className="field-value">
                    {detail.innerVendorName}({detail.innerVendorCode})
                  </div>
                </li>
                <li>
                  <span className="field-label">验收单号</span>
                  <div className="field-value">{detail.accpInnerNo}</div>
                </li>
                {
                  <li>
                    <span className="field-label">建单日期</span>
                    <div className="field-value">
                      {formatDate(detail.createTime, 'YYYY-MM-DD')}
                    </div>
                  </li>
                }
                <li>
                  <span className="field-label">工厂</span>
                  <div>{detail.profitCenterName}</div>
                </li>
                <li>
                  <span className="field-label">采购单号</span>
                  <div className="field-value">{detail.poErpNo}</div>
                </li>
                <li>
                  <span className="field-label">状态</span>
                  <div className="field-value">
                    <span
                      className={
                        'u-sign ' +
                        CommonFns.getStatusClass('paas', detail.status)
                      }
                    >
                      {detail.statusName}
                    </span>
                  </div>
                </li>
                {/* 审批流状态 仅开启后才显示 */}
                {self.isPurchase && updateTs > 0 && workflow.isActive && (
                  <li>
                    <span className="field-label">审批环节</span>
                    <div className="field-value">
                      <WorkflowStatus
                        companyCode={companyCode}
                        id={self.id}
                        workflow={workflow}
                        detail={detail}
                      />
                    </div>
                  </li>
                )}
                {/* 审批流按钮 */}
                {self.isPurchase && updateTs > 0 && workflow.isActive && (
                  <li>
                    <span className="field-label">审批操作</span>
                    <div className="field-value">
                      <WorkflowButtons
                        companyCode={companyCode}
                        id={self.id}
                        workflow={workflow}
                        detail={detail}
                        onChange={() => {
                          self.getDetail();
                        }}
                      />
                    </div>
                  </li>
                )}
              </ul>
            </div>
          </div>
        </div>

        {/*验收明细 */}
        {!Util.isEmpty(detail.lineList) && (
          <div className="m-details-item">
            <div className="details-item-title">
              <label>验收明细</label>
            </div>
            <div className="details-item-content">
              {detail.lineList.map((item, index) => (
                <div className="content-line line-list-item" key={index}>
                  <div className="line-list-item-title">
                    <span>采购项次 {item.poLineNo}</span>
                  </div>
                  <ul className="field-list">
                    <li>
                      <span className="field-label">产品编码</span>
                      <div className="field-value">{item.productCode}</div>
                    </li>
                    <li>
                      <span className="field-label">产品名称</span>
                      <div className="field-value">{item.productName}</div>
                    </li>
                    <li>
                      <span className="field-label">产品规格</span>
                      <div className="field-value">{item.productScale}</div>
                    </li>
                    {item.printExtendFields !== '' && (
                      <li>
                        <span className="field-label">采购说明</span>
                        <div className="field-value">
                          {item.printExtendFields}
                        </div>
                      </li>
                    )}
                    <li>
                      <span className="field-label">付款说明</span>
                      <div className="field-value">{item.payDesc}</div>
                    </li>
                    <li>
                      <span className="field-label">付款比例</span>
                      <div className="field-value">{item.payRatioShow}</div>
                    </li>
                    <li>
                      <span className="field-label">待验收数量</span>
                      <div className="field-value">
                        {formatNumber(item.waitAccpQty, decimalPlace.QTY)}
                      </div>
                    </li>
                    <li>
                      <span className="field-label">待验收金额</span>
                      <div className="field-value">
                        {item.isContainTax
                          ? formatNumber(
                              item.waitAccpTaxLineAmount,
                              decimalPlace.AMOUNT
                            )
                          : formatNumber(
                              item.waitAccpLineAmount,
                              decimalPlace.AMOUNT
                            )}
                      </div>
                    </li>
                    <li>
                      <span className="field-label">验收数量</span>
                      <div className="field-value">
                        {formatNumber(item.accpQty, decimalPlace.QTY)}
                      </div>
                    </li>
                    <li>
                      <span className="field-label">验收金额</span>
                      <div className="field-value">
                        {item.isContainTax
                          ? formatNumber(
                              item.accpTaxLineAmount,
                              decimalPlace.AMOUNT
                            )
                          : formatNumber(
                              item.accpLineAmount,
                              decimalPlace.AMOUNT
                            )}
                      </div>
                    </li>
                    <li>
                      <span className="field-label">单价</span>
                      <div className="field-value">
                        {formatNumber(
                          item.isContainTax ? item.taxPrice : item.price,
                          decimalPlace.PRICE
                        )}
                      </div>
                    </li>
                    <li>
                      <span className="field-label">币别</span>
                      <div className="field-value">{item.currencyName}</div>
                    </li>
                    <li>
                      <span className="field-label">税率</span>
                      <div className="field-value">{item.taxRateShow}</div>
                    </li>
                    <li>
                      <span className="field-label">附件</span>
                      <div className="field-value">
                        {!Util.isEmpty(item.fileMd5s) &&
                          item.fileMd5s.length > 0 && (
                            <span
                              className="attachment"
                              onClick={() => showFileList(item)}
                            >
                              {item.fileMd5s.length}个附件
                              <i className="icon-attachment"></i>
                            </span>
                          )}
                      </div>
                    </li>
                    <li>
                      <span className="field-label">备注</span>
                      <div className="field-value">{item.remark}</div>
                    </li>
                  </ul>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* 验收说明 */}
        {
          <div className="m-details-item">
            <div className="details-item-title">
              <label>验收说明</label>
            </div>
            <div className="details-item-content">
              <div className="content-line">
                <ul className="field-list">
                  <li>
                    <div className="field-value">{detail.description}</div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        }
        {/* 附件 */}
        {
          <div className="m-details-item">
            <div className="details-item-title">
              <label>附件</label>
            </div>
            <div className="details-item-content">
              <div className="content-line">
                <ul className="field-list">
                  <li>
                    <div className="field-value">
                      {!Util.isEmpty(detail.fileMd5s) &&
                        detail.fileMd5s.length > 0 && (
                          <span
                            className="attachment"
                            onClick={() => showFileList(detail)}
                          >
                            {detail.fileMd5s.length}个附件
                            <i className="icon-attachment"></i>
                          </span>
                        )}
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        }
      </div>
      {self.isPurchase && (
        <div className="wrap m-flex-box fixed-bottom">
          {User.checkAuth('10031204') &&
            [1].includes(detail.status) &&
            workflow.data &&
            workflow.data['accp_audit'].complete && (
              <Button
                type="default"
                onClick={() => {
                  confirm();
                }}
                className="m-flex-item u-btn u-btn_primary"
              >
                确认
              </Button>
            )}
        </div>
      )}

      <Modal></Modal>
      {
        // 附件查看
        Array.isArray(fileList) && fileList.length > 0 && (
          <Download fileList={fileList} />
        )
      }
    </div>
  );
}

ReceiveAcceptanceDetail.propTypes = {
  data: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  return {
    data: state.login
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReceiveAcceptanceDetail);
